export default __webpack_public_path__ + "static/media/title.7b303ea1.svg";